// initial state
const state = () => ({
  open: false,
  openNewsletterModal: false
});

// functionName: (state, getters, rootState) => {}
const getters = {};

// functionName ({ commit, state, dispatch }, param, ...) {}
const actions = {
  open({ commit }) {
    commit("open");
    document.body.classList.add("openedSearchFormModal");
    document.querySelector("#search-form-modal").focus();
  },

  close({ commit }) {
    commit("close");
    document.body.classList.remove("openedSearchFormModal");
  }
};

// functionName (state, { param, ... }) {
const mutations = {
  open(state) {
    state.open = true;
  },

  close(state) {
    state.open = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
